export default __webpack_public_path__ + "static/media/teamMember.7e962cbb.jpg";